import axios from 'axios';
import { ListChannel } from "./../constants/setting_channel";
import { getApiHeader } from './../services/getApiHeaders';

export function verifyChannel(payload) {
    let data = {
        ChannelId: payload.channel_id,
        SellerId: (' ' + payload.seller_id).trim(),
        AuthToken: (' ' + payload.auth_token).trim(),
    };

    const options = {
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/eccredential/verifysetting',
        headers: getApiHeader(),
        withCredentials: true,
        data,
    }
    return axios(options)
}

export function saveChannel(payload) {
    let data = {
        ChannelId: payload.channel_id,
        SellerId: (' ' + payload.seller_id).trim(),
        AuthToken: (' ' + payload.auth_token).trim(),
    };

    const options = {
        method: 'PUT',
        url: process.env.REACT_APP_URL + '/api/eccredential/savesetting',
        headers: getApiHeader(),
        withCredentials: true,
        data,
    }
    return axios(options)
}

export function getChannel(payload) {
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/eccredential/getsetting?channelId=' +  payload.channel_id,
        withCredentials: true,
        headers: getApiHeader(),
    }
    return axios(options)
}



// WEBPACK FOOTER //
// ./src/utils/settingChannel.js